import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";
import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/EventHelpers/EventHelpers";

class ShowHideHelp extends Class {
  constructor(element) {
    super();
    this.setUpElements(element);
    this.setUpEvents();
  }

  setUpElements(element) {
    this.element = $(element);
    this.helpText = this.element.find(".toggleHelpText");
  }

  setUpEvents() {
    var self = this;

    this.element.on("click", function(evt) {
      if ($(evt.target).is("a[data-show-help]")) {
        self.toggleMenu();
        evt.preventDefault();
        $(self).trigger("toggle", self);
      }
    });
  }

  toggleMenu() {
    if (this.isHidden()) {
      this.show();
    } else {
      this.hide();
    }
  }

  isHidden() {
    return this.element.hasClass("hidden");
  }

  hide() {
    this.element.addClass("hidden");
    this.element.removeClass("show");
  }

  show() {
    this.element.removeClass("hidden");
    this.element.addClass("show");
  }
}

export { ShowHideHelp };



// WEBPACK FOOTER //
// ./Javascript/core/classes/searchresults/search.help.js